import { faTimes } from '@fortawesome/pro-light-svg-icons'
import TwinIcon from '../../TwinIcon'
import { RectangularInputFormatNumberSmall } from '../../../forms/Input'
import { useCallback, useState } from 'react'
import { addOrRemoveClassList } from '../../../utils/globals/components'


interface RangeTableHeaderProps extends RangeTableHeaderLogicProps {
    tag: string
    deleteRange: (pos: number)=> void
}

const RangeTableHeader: React.FC<RangeTableHeaderProps> = ({ ranges, tag, pos, onChangeRanges, deleteRange }) => {
    const { myRange, handleChangeRange, onBlurRange } = useRangeTableHeaderLogic({ pos, ranges, onChangeRanges })
    return (
        <div className=' bg-gray-F7 h-full flex items-center w-130 p-10 range_header'>
            <TwinIcon icon={faTimes} className='hover:text-red-BA cursor-pointer pr-10 w-7' onClick={() => deleteRange(pos)} />
            <div className='flex items-center input_quantity'>
                <RectangularInputFormatNumberSmall className=' w-70 ' value={myRange} onChange={(val) => handleChangeRange(val)} onBlur={onBlurRange} />
                <span className='ml-10'>{tag}</span>
            </div>
        </div>
    )
}
interface RangeTableHeaderLogicProps {
    pos: number
    ranges: number[]
    onChangeRanges: ( ranges: number[])=> void
}

const useRangeTableHeaderLogic = ({ onChangeRanges, pos, ranges }: RangeTableHeaderLogicProps) => {
    const [myRange, setMyRange] = useState<string>(String(ranges[pos]))

    const handleChangeRange = useCallback((val: string) => {
        setMyRange(val)
    }, [setMyRange])

    const onBlurRange = useCallback((e: any) => {
        const belowRange = ranges?.[pos - 1]
        const overRange = ranges?.[pos + 1]
        const parseFloatRange = parseFloat(myRange || '0')
        let isNotValid = !checkChangeRangeValidity(parseFloatRange, belowRange, overRange)
        addOrRemoveClassList(e.currentTarget.parentElement, 'input_error', isNotValid)
        if (isNotValid) {
            setMyRange(String(ranges[pos]))
        } else {
            const copy = JSON.parse(JSON.stringify(ranges))
            copy.splice(pos, 1,  parseFloat(myRange))
            onChangeRanges(copy)
        }
    }, [setMyRange, pos, myRange, ranges, onChangeRanges])

    return { handleChangeRange, myRange, onBlurRange }
}


const checkChangeRangeValidity = (range: number, belowRange?: number, overRange?: number) => {
    if (belowRange !== undefined && belowRange >= range) {
        return false
    } else if (overRange && overRange <= range) {
        return false
    }
    return true
}

export default RangeTableHeader